/* eslint-disable jsx-a11y/label-has-associated-control */

import React from "react";
import { faUserPlus, faUserCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppTranslation } from "../../../../../../../../../i18n/useAppTranslation";
import { useContext } from "../../../context";
import MembershipBadge from "../../../../../../../../Common/MembershipBadge";

const getMembershipBadgeKey = (membership, keyCounts) => {
  const keyBase = [
    membership.color || "default",
    membership.onHold ? "on-hold" : "active",
  ].join("-");
  const keyCount = keyCounts.get(keyBase) || 0;

  keyCounts.set(keyBase, keyCount + 1);

  return keyCount ? `${keyBase}-${keyCount}` : keyBase;
};

export function Patient() {
  const { appointment } = useContext();
  const membershipBadgeKeyCounts = new Map();

  const isMembershipsVisible =
    appointment.patient?.isMonthlyMembership ||
    ["juvly_member", "both"].includes(appointment.patient?.memberType);

  const isNewPatient = appointment.patient?.type === "New";

  return (
    <div className="detail-row relative">
      <label>
        <AppTranslation.Common path="label.patient" />:
      </label>
      <span>
        <a
          href={`/clients/profile/${appointment.patientId}`}
          rel="noopener noreferrer"
          target="_blank"
          className="easy-link pull-left no-padding"
        >
          {appointment.patient?.fullName}
        </a>
      </span>
      <div className="TypeOfClient d-flex items-center">
        <div className="d-flex gap-8 m-b-10 items-center">
          {isMembershipsVisible &&
            appointment.patient?.memberships?.map((m) => (
              <MembershipBadge
                key={getMembershipBadgeKey(m, membershipBadgeKeyCounts)}
                color={m.color}
                onHold={m.onHold}
                displayPage="appointment-details-popup"
              />
            ))}
        </div>
        <div
          className={
            isNewPatient
              ? "patient-type patient-type--new"
              : "patient-type patient-type--existing"
          }
        >
          <FontAwesomeIcon
            icon={isNewPatient ? faUserPlus : faUserCheck}
            size="xs"
          />
          {appointment.patient?.type}
        </div>
      </div>
    </div>
  );
}
